<template>
    <div>
        <template v-for="(row, index) in competitorUrls">
            <Competitor :row="row"
                        :competitors-list="competitorsList"
                        :key="row.competitor.id + index"
                        :using-ids="usingIds"
                        @save="(newVal) => sendThisToParent(newVal, index)"
                        @delete="removeCompetitorUrlOnParent(index)"/>
        </template>

        <Competitor v-if="addingNewUrl"
                    :competitors-list="competitorsList"
                    key="newCompetitor"
                    :using-ids="usingIds"
                    @save="(newVal) => sendThisToParent(newVal)"
                    @delete="removeCompetitorUrlOnParent()"/>

        <div>
            <button class="small"
                    @click.prevent.stop="addCompetitorUrl()"
                    :disabled="addButtonDisabled">
                добавить
            </button>
        </div>
    </div>
</template>

<script>
    import Competitor from "../../components/clinic/Competitor";

    export default {
        components: {
            Competitor,
        },
        props: {
            competitorsList: {
                type: Array,
                required: true,
            },
            competitorUrls: {
                type: Array,
                default: () => [],
            }
        },
        data: function () {
            return {
                addingNewUrl: false,
            }
        },
        created() {
            if (!this.addButtonDisabled) {
                this.addCompetitorUrl()
            }
        },
        methods: {
            addCompetitorUrl() {
                if (!this.addingNewUrl) {
                    this.addingNewUrl = true;
                }
            },
            sendThisToParent(newVal, index = null) {
                this.$emit('send-url', {
                    newVal: newVal,
                    index: index,
                });
            },
            removeCompetitorUrlOnParent(index = null) {
                if (index !== null) {
                    this.$emit('remove-url', index)
                } else {
                    this.addingNewUrl = false;
                }
            },
        },
        computed: {
            usingIds() {
                if (this.competitorUrls && this.competitorUrls.length > 0) {
                    return this.competitorUrls.map((url) => url.competitor.id)
                }

                return []
            },
            addButtonDisabled() {
                return this.usingIds && (this.competitorsList.length <= this.usingIds.length)
            }
        }
    }
</script>
